import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'il',
  resources: {
    en: {
      translations: require('./locales/en/translations.json')
    },
    il: {
      translations: require('./locales/il/translations.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'il'];

export default i18n;